import script from "./RoadmapView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadmapView.vue?vue&type=script&setup=true&lang=js"

import "./RoadmapView.vue?vue&type=style&index=0&id=e266b6d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e266b6d6"]])

export default __exports__